import React from 'react';
import { MetricsRow } from '../components/dashboard/Metrics';
import { FloorPlan } from '../components/dashboard/FloorPlan';
import { PrepList } from '../components/dashboard/PrepList';
import { ReservationsList } from '../components/dashboard/Reservations';
import { TableTurnLogo } from '../components/brand/Logo';

export const Dashboard = () => {
  return (
    <div className="p-6 space-y-8 max-w-[1400px] mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-chefPanel/50 pb-6">
        <div className="flex items-center gap-4">
          <TableTurnLogo size="lg" className="hidden sm:flex" />
          <div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-status-open rounded-full animate-pulse"></div>
              <h1 className="text-3xl font-black text-receiptWhite tracking-tight">SERVICE COMMAND</h1>
            </div>
            <p className="text-receiptMuted text-sm font-mono uppercase tracking-widest mt-1 opacity-70">Shift 1284 // Dinner Service // Floor Alpha</p>
          </div>
        </div>
        <div className="flex gap-3 w-full md:w-auto">
          <button className="flex-1 md:flex-none bg-chefDark border border-chefPanel hover:bg-chefPanel text-receiptWhite px-6 py-2.5 rounded font-mono text-xs uppercase tracking-widest transition-all">
            Export Log
          </button>
          <button className="flex-1 md:flex-none bg-chiliRed hover:bg-chiliDark text-white px-6 py-2.5 rounded font-mono text-xs uppercase tracking-widest transition-all shadow-glow-red">
            New Walk-in
          </button>
        </div>
      </div>

      <MetricsRow />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 flex flex-col">
          <FloorPlan />
        </div>
        <div className="flex flex-col">
          <ReservationsList />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <PrepList />
        <div className="bg-chefDark border border-chefPanel rounded-xl p-8 flex flex-col justify-center items-center text-center relative overflow-hidden group">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-chiliRed/40 to-transparent"></div>
          <div className="w-16 h-16 bg-status-open/10 rounded-full flex items-center justify-center mb-6 text-status-open group-hover:scale-110 transition-transform duration-500">
            <span className="text-3xl">★</span>
          </div>
          <h3 className="text-2xl font-bold text-receiptWhite mb-3">Service Health: Optimal</h3>
          <p className="text-receiptMuted text-sm max-w-sm leading-relaxed font-mono uppercase tracking-tighter opacity-80">
            Zero critical inventory alerts. <br/>
            Guest satisfaction index: 4.8 / 5.0 <br/>
            Staff efficiency: +14% vs baseline
          </p>
          <div className="mt-8 flex gap-4">
             <div className="text-center">
                <div className="text-receiptWhite font-bold">142</div>
                <div className="text-[10px] text-receiptMuted uppercase">Covers</div>
             </div>
             <div className="w-px h-8 bg-chefPanel"></div>
             <div className="text-center">
                <div className="text-receiptWhite font-bold">0</div>
                <div className="text-[10px] text-receiptMuted uppercase">Voids</div>
             </div>
             <div className="w-px h-8 bg-chefPanel"></div>
             <div className="text-center">
                <div className="text-receiptWhite font-bold">48m</div>
                <div className="text-[10px] text-receiptMuted uppercase">Avg Turn</div>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};